import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { CircularProgress } from "@mui/material";
import Swal from "sweetalert2";

const LoginForm = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const serverURL = process.env.REACT_APP_URL;

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setIsLoading(true);
      const response = await axios.post(`${serverURL}/api/auth/login`, {
        email,
        password,
      });
      const { token, role, userId, emailId, name, superAdminEmail } =
        response.data;
      localStorage.setItem("token", token);
      localStorage.setItem("role", role);
      localStorage.setItem("userId", userId);
      localStorage.setItem("email", emailId);
      localStorage.setItem("name", name);
      localStorage.setItem("superAdminEmail", superAdminEmail);

      if (role === -1) navigate("/adminportal/dashboard");
      else navigate("/adminportal/vendorDetails");
    } catch (err) {
      Swal.fire({
        icon: "error",
        text:
          err?.response?.data?.message ||
          "Something went wrong. Please try again.",
      });
      setIsLoading(false);
    }
  };

  return (
    <div className="flex justify-center items-center h-screen bg-gray-100 p-4">
      <div className="flex bg-white shadow-lg rounded-lg overflow-hidden max-w-4xl w-full">
        {/* Left Side - Login Form */}
        <div className="w-1/2 p-8">
          <div className="flex justify-center mb-6">
            <img
              src="/assests/images/pixell dark.png"
              alt="Logo"
              className="h-10"
            />
          </div>
          <h2 className="text-2xl font-bold text-center mb-6">
            Sign in to your account
          </h2>
          <form onSubmit={handleSubmit}>
            <div className="mb-4">
              <label className="block text-gray-600">Your email</label>
              <input
                type="email"
                className="w-full p-2 mt-2 border rounded"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <div className="mb-4">
              <label className="block text-gray-600">Password</label>
              <input
                type="password"
                className="w-full p-2 mt-2 border rounded"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
            <button
              disabled={isLoading}
              type="submit"
              className="w-full p-2 bg-blue-600 hover:bg-blue-700 text-white rounded"
            >
              {isLoading ? (
                <CircularProgress size={20} color="inherit" />
              ) : (
                "Sign in"
              )}
            </button>
            <p className="text-center text-gray-500 text-sm mt-4">
              Don't have an account?{" "}
              <a
                href="https://pixell.in"
                className="text-blue-500 hover:underline"
              >
                Go to Website
              </a>
            </p>
          </form>
        </div>

        {/* Right Side - Image */}
        <div
          className="w-1/2 bg-cover bg-center"
          style={{
            backgroundImage: "url('/assests/AdminDashboard/Login-banner.jpg')",
          }}
        >
          <div className="flex flex-col justify-center h-full bg-blue-900 bg-opacity-60 text-white p-8">
            <h2 className="text-2xl font-bold">
              Transforming Local Advertising with Seamless Signage Solutions
            </h2>
            <ul className="mt-4 space-y-2">
              <li>
                ✅ Connect with trusted hyperlocal signage vendors effortlessly.
              </li>
              <li>
                ✅ Ensure agility, visibility, and quality in every campaign.
              </li>
              <li>✅ Manage and monitor your signage network with ease.</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginForm;
